// extracted by mini-css-extract-plugin
export var readonly = "_dh-1";
export var star = "_dh-0";